import * as classNames from 'classnames';
import DatePicker from 'react-datepicker';
// import de from 'date-fns/locale/de';
import formStyle from '../style/WForm.less';
import * as Moment from 'moment';
import * as React from 'react';
// import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { WActionButton } from '../../elements/WActionButton';
import { getKomplexRowClassname } from '../../../main/functions/getFormKey';
import '../style/WFormFieldDateTime.css';

// registerLocale('de', de);

interface WFormFieldDateTimeProps extends React.ClassAttributes<any> {
    label: JSX.Element;
    name: string;
    value: number;
    row?: any;
    withTimePicker: boolean;
    layout?: string;
    required?: boolean;
    readonly?: boolean;
    showMode?: boolean;
    allowFuture?: boolean;
    warn?: string;
    disabled?: boolean;
    autofill?: boolean;
    minDate?: Date;
    maxDate?: Date;
    hideButtons?: boolean;
    hideClockSetTime?: boolean;
    datePickerCustomClass?: any;
    allValues?: any; // Das gesamte Formular
    WActionButtonStyleProps?: React.CSSProperties;
    errorLevelKey?: string;
    onValueChange(name: string, value: any): void;
    custom_component?: (setValue?: (value: number) => void) => JSX.Element;
}

export interface WFormFieldDateTimeState extends React.ClassAttributes<any> {
    datetime: number;
}

export class WFormFieldDateTime extends React.Component<WFormFieldDateTimeProps, WFormFieldDateTimeState> {

    constructor(props: any) {
        super(props);
        const startVal = this.props.value > 0
            ? this.props.value
            : (this.props.autofill === false ? null : Date.now() / 1000);
        this.state = {
            datetime: startVal
        };
        this.onDatePickerChange = this.onDatePickerChange.bind(this);
        this.onSetDateTime = this.onSetDateTime.bind(this);
        this.props.onValueChange(this.props.name, startVal);
        this.setTimeAuto = this.setTimeAuto.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props: any) {
        this.setState({ datetime: props.value || null });
    }

    onDatePickerChange(date: any) {
        // console.log('D:', date);
        if (!date) {
            return;
        }
        let datetime: number;
        if (date instanceof Date) {
            datetime = date.getTime() / 1000;
        } else {
            datetime = date.toDate().getTime() / 1000;
        }
        this.setState({ datetime });
        this.props.onValueChange(this.props.name, datetime);
    }

    setTimeAuto() {
        // Spezial-Fall-Behandlung
        // Eigentlich unschön an dieser Stelle, da das aber sowieso nur für's E-Tool verwendet wird, ist es ok.
        if (this.props.name === 'abrechnungszeitraum_von' && this.props.allValues && this.props.allValues.jahr) {
            const d = new Date(`1/1/${this.props.allValues.jahr}`);
            this.onSetDateTime(d.getTime() / 1000);
        } else if (this.props.name === 'abrechnungszeitraum_bis' && this.props.allValues && this.props.allValues.jahr) {
            const d = new Date(`12/31/${this.props.allValues.jahr}`);
            this.onSetDateTime(d.getTime() / 1000);
        } else {
            this.onSetDateTime(Date.now() / 1000);
        }
    }

    onSetDateTime(stamp: number) {
        const datetime = stamp;
        this.setState({ datetime });
        this.props.onValueChange(this.props.name, datetime);
    }

    render() {
        const { showMode, value, errorLevelKey, custom_component } = this.props;
        const disabled = this.props.readonly || this.props.disabled ? true : false;
        const hideButtons = this.props.hideButtons;
        const hideClockSetTime = true || this.props.hideClockSetTime; // WAEW-260: erstmal deaktivieren
        const errInputStyle = typeof errorLevelKey === 'string' && errorLevelKey === 'error' ? formStyle.errorlevel_default : null;
        const krCls = getKomplexRowClassname((this.props.row || {})._formKey, this.props.name) || undefined;

        if (showMode) {
            return (
                <div className={classNames(formStyle.fieldBox, krCls)}>
                    {this.props.label}
                    <div className={classNames(formStyle.input, formStyle.showMode, errInputStyle)}>
                        {Moment(value * 1000).format('DD.MM.YYYY')}
                    </div>
                </div>
            );
        }

        const isComplexLayout: boolean = this.props.layout === 'sidebysideComplex' || this.props.layout === 'sidebysideComplexGreen';

        return (
            <div className={classNames(formStyle.fieldBox, krCls)}>
                {this.props.label}
                <div className={formStyle.input}>
                    <div>
                        <div
                            style={{
                                display: 'flex', flexDirection: 'row', justifyContent: 'left',
                                ...(isComplexLayout ? {} : { alignItems: 'center' })
                            }}
                            className={classNames(formStyle.datePicker)}
                        >
                            <DatePicker
                                name='date'
                                className={classNames(formStyle.input, formStyle.datePickerInput, this.props.datePickerCustomClass, errInputStyle)}
                                popperProps={{ positionFixed: true, strategy: 'fixed' }}
                                selected={this.state.datetime > 0 ? Moment.unix(this.state.datetime).toDate() : null}
                                onChange={this.onDatePickerChange}
                                locale='de'
                                showMonthDropdown
                                useShortMonthInDropdown
                                showYearDropdown
                                dropdownMode='scroll'
                                showTimeSelect={this.props.withTimePicker}
                                timeFormat='HH:mm:ss'
                                timeIntervals={5}
                                dateFormat={this.props.withTimePicker ? 'dd.MM.yyyy HH:mm:ss' : 'dd.MM.yyyy'}
                                minDate={this.props.minDate ? this.props.minDate : Moment(new Date(2010, 0, 1)).toDate()}
                                maxDate={this.props.maxDate
                                    ? this.props.maxDate
                                    : this.props.allowFuture ? Moment().add(30, 'years').toDate() : Moment(new Date()).toDate()
                                }
                                todayButton='Heute'
                                disabled={disabled}
                            />
                            {!disabled && !hideButtons && !hideClockSetTime &&
                                <WActionButton
                                    styleProps={this.props.WActionButtonStyleProps}
                                    tooltip='Datum automatisch setzen'
                                    label='Datum automatisch setzen'
                                    action='clockSetTime'
                                    onAction={(action: string) => this.setTimeAuto()}
                                />
                            }
                            {!disabled && !hideButtons &&
                                <WActionButton
                                    {...{
                                        styleProps: {
                                            ...(this.props.WActionButtonStyleProps || {}),
                                            ...(isComplexLayout ? {} : {})
                                        },
                                        tooltip: 'Eingabe entfernen',
                                        label: 'Eingabe entfernen',
                                        action: 'delete',
                                        onAction: (action: string) => this.onSetDateTime(null)
                                    }}
                                />
                            }
                        </div>
                        {this.props.warn &&
                            <div style={{ fontSize: 12, fontWeight: 'bold', color: '#f00' }}><br />{this.props.warn}</div>
                        }
                    </div>
                    {typeof custom_component === 'function' &&
                        <div>{custom_component(this.onSetDateTime)}</div>
                    }
                </div>
            </div>
        );
    }
}
